<template>
  <v-app
    class='white'
    light
  >
    <v-content>
      <section>
        <div v-if='$vuetify.breakpoint.xsOnly' >
        <v-img
          
          class='white'
          src="../../assets/staticAsset/headerXs.png"
          contain
          style='cursor: pointer'>
 <v-btn
            style='float:right'
            color='primary'
            href="/login">Login</v-btn>
        </v-img>
        </div>
        <div v-else>
          <v-img v-if='!$vuetify.breakpoint.xsOnly'
          class='white'
          src="../../assets/staticAsset/header.png"
          contain>
          <v-btn
            style='float:right'
            color='primary'
            href="/login">Login</v-btn>
        </v-img>
        </div>
        

      </section>
      <section>

        <v-card outlined flat color='#399342' class='mt-n1 white--text'>
           <v-col
        md="8"
        offset-md="2"
      >
         <p  class="mt-2 headline font-weight-bold  text-center"> My Genetic Trust is your one-stop resource to safely gather your family's genetic health information for yourself and for future generations.</p>
           </v-col>
        </v-card>


      </section>
      <section>
        <v-layout
          row
          wrap
          align-center
          class="my-12"
        >

          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout
                row
                align-center
              >
                <v-flex
                  xs12
                  md8
                >
                  <v-card
                    flat
                    class="transparent"
                  >

                    <v-card-text>

                      <p class=' font-weight-regular title'>
                        Use our encrypted, convenient online portal to document your personal and family
                        medical records, securely bank your DNA, and create a personalized genetic story.
                        Rest assured that your data will be safe and accessible to designated family members for years to
                        come.
                      </p>
                      <p class=' font-weight-regular title'>
                        Developed by the experts at Genetic Support Foundation, My Genetic Trust is designed to give you the most comprehensive summary of your relevant health and
                        family health history. Our team of certified genetic counselors knows the field of genetics is rapidly expanding and uncovering significant discoveries. We want you to be
                        prepared.
                      </p>
                      <p class='font-weight-regular title'  >Let's get started. </p>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text class="text-center">
                      <img src='../../assets/staticAsset/GSF_InitialStyleSketches-scientist-green.png' />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card
                    flat
                    class="transparent"
                  >

                      <div class="headline text-center">
                           <div class="container">
        <div class="col-md-12 col-md-offset-1">
          <sTable />
        </div>

    </div>
                      </div>

                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md8
                >
                  <v-card
                    flat
                    class="transparent"
                  >

                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">My Genetic Trust Plus</p>
                      <p class='font-weight-regular mt-n3 title'>
                        Once you complete a family history intake form, one of our certified genetic
                        counselors will review your information, identify any additional records that
                        would be useful, and pinpoint any indications that meet criteria for genetic
                        counseling or consideration of genetic testing. You and your named
                        beneficiaries will be able to access your genetic story online through a secure
                        HIPAA-compliant portal.
                      </p>
                      <v-btn

                        color="#399342"
                        dark
                        large
                        to="/public/plus"
                      >
                        Learn More
                      </v-btn>
                    </v-card-text>

                  </v-card>
                </v-flex>

                <v-flex
                  xs12
                  md4
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text class="text-center">
                      <img src='../../assets/staticAsset/GSF_Sketch-Family-Color-00.jpg' />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md8
                >
                  <v-card
                    flat
                    class="transparent"
                  >

                    <v-card-text>
                      <p class="title font-weight-bold mainBlue ">My Genetic Trust Complete</p>
                      <p class='font-weight-regular mt-n3 title'>
                        DNA banking can be an important piece of your family's health puzzle. In
                        addition to the certified review of your documentation, you will be supported
                        through the process of DNA banking with one of our partner laboratories. Your
                        DNA sample, along with your genetic story, can be accessed in the future as new
                        genetic discoveries come to light.
                      </p>
                      <v-btn

                        color="#399342"
                        dark
                        large
                        to="/public/complete"
                      >
                        Learn More
                      </v-btn>
                    </v-card-text>

                  </v-card>
                </v-flex>
                <v-flex
                  class='mt-2'
                  xs12
                  md8
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text>
                      <p class="title font-weight-bold mainBlue ">My Genetic Trust Concierge</p>
                      <p class='font-weight-regular mt-n3 title'>
                        Tracking down records can be a tedious and laborious process. Let us do that
                        for you. We will work with you and your family members to obtain and organize
                        those records. In addition, we will offer all of the benefits of My Genetic Trust
                        Complete. Many clients find this option complementary to estate and will
                        planning.

                      </p>

                      <v-btn

                        color="#399342"
                        dark
                        large
                        to="/public/concierge"
                      >
                        Learn More
                      </v-btn>
                        
                       <p class="pt-10 subtitle-1">
                       <b>Privacy is Important</b>
                      </p>
                        <p class="subtitle-1">
                       My Genetic Trust allows for secure storage of your important health and family medical records and (if selected) banked DNA. You can rest assured that your sensitive information will never be sold and will only be shared with your designated beneficiaries.
                      </p>
                    </v-card-text>

                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md8
                >
                  <v-card
                    flat
                    class="transparent"
                  >

                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">Looking for More?</p>
                      <p class='font-weight-medium title'>
                       If you’re looking for more information and support, visit our parent foundation at
                      <a style='color:#399342' target='blank' href='https://www.geneticsupportfoundation.org'>GeneticSupportFoundation.org</a>.
                      </p>


                    </v-card-text>

                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text class="text-center">
                      <img src='../../assets/staticAsset/GSF_Sketch-Couple-Color-00.jpg' />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <!-- footer section -->
      <v-footer
        class='footer white'
        color="darken-2"
      >
      <sfooter />
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import sTable from "../../components/staticPage/Table"
import sfooter from "../../components/staticPage/Footer"
export default {
  components : {
    sfooter,
    sTable,
  },
  mounted () {
  }
}
</script>

<style scoped>
.mainBlue {
  color: #399342;
}


</style>
